import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";

const Header = styled("h4")`
  padding: ${({ theme }) => theme.spacing(1)};
  margin: 0px;
`;

export const SettingsSection = ({ children, title }) => {
  // A common container for the settings components
  return (
    <Box>
      <Header>{title}</Header>
      {children}
    </Box>
  );
};

SettingsSection.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string
};
